/*
 * @Author: Ryan
 * @Date: 2026-02-03
 * @Description: SEO sections entry file for video-subtitle-remover page
 */
import React from 'react';

import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import FeaturesSection from './FeaturesSection';
import HowToUseSection from './HowToUseSection';
import ShowcaseSection from './ShowcaseSection';
import TestimonialsSection from './TestimonialsSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      <ShowcaseSection />
      <HowToUseSection />
      <FeaturesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;

// 导出 ImageComparePlayer 供外部使用
export { default as ImageComparePlayer } from './ImageComparePlayer';
